const $navbarStart = $('.navbar-start');
const $offerExpanded = $('.offer-links--expanded');
const $offerMerged = $('.offer-links--merged');
const $aboutUsExpanded = $('.about-us-links--expanded');
const $aboutUsMerged = $('.about-us-links--merged');

function enforceExpanded($expandedGroup, $mergedGroup) {
    $expandedGroup.removeClass('is-hidden');
    $mergedGroup.addClass('is-hidden');
}

function toggleGroup($navbar, $expandedGroup, $mergedGroup) {
    $expandedGroup.removeClass('is-hidden');
    $mergedGroup.addClass('is-hidden');

    let containerWidth = $navbar.outerWidth(true);
    let allItemsWidth = 0;
    let offerItemsWidth = 0;

    $('> *', $navbar).each(function() { allItemsWidth += $(this).outerWidth(true); });
    $expandedGroup.each(function() { offerItemsWidth += $(this).outerWidth(true); });

    if (((offerItemsWidth > 0) && (allItemsWidth - containerWidth >= -1)) || allItemsWidth === 0) {
        $expandedGroup.addClass('is-hidden');
        $mergedGroup.removeClass('is-hidden');
    } else {
        enforceExpanded($expandedGroup, $mergedGroup);
    }
}

function toggleNavigationGroups() {

    enforceExpanded($offerExpanded, $offerMerged);
    enforceExpanded($aboutUsExpanded, $aboutUsMerged);

    toggleGroup($navbarStart, $offerExpanded, $offerMerged);
    toggleGroup($navbarStart, $aboutUsExpanded, $aboutUsMerged);

    $('.navbar__hidden-items').removeClass('navbar__hidden-items');
}

$(window).on('load resize', function () {
    toggleNavigationGroups();
});

toggleNavigationGroups();
